export const inventoryCurrency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export function categoryLabel(category) {
  return category === "metal" ? "Metal building or carport" : "Shed or portable building";
}

export function itemDimensions(item) {
  const match = String(item.title ?? "").match(/\b(\d{1,2})\s*(?:x|×|'\s*×)\s*(\d{1,2})\b/i);
  return match ? `${match[1]}′ × ${match[2]}′` : "Dimensions not listed";
}

export function itemModel(item) {
  const model = String(item.title ?? "").replace(/^\s*\d{1,2}\s*(?:x|×|'\s*×)\s*\d{1,2}'?\s*/i, "").trim();
  return model || String(item.title ?? "Building");
}

export function displayedPrice(item) {
  const price = item.price === null || item.price === "" ? NaN : Number(item.price);
  return Number.isFinite(price) ? inventoryCurrency.format(price) : "Call for current price";
}
